export default function SunsetGradientIcon(): JSX.Element {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 18C17 16.6739 16.4732 15.4021 15.5355 14.4645C14.5979 13.5268 13.3261 13 12 13C10.6739 13 9.40215 13.5268 8.46447 14.4645C7.52678 15.4021 7 16.6739 7 18"
        stroke="url(#paint0_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 9V2"
        stroke="url(#paint1_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.21875 10.2197L5.63875 11.6397"
        stroke="url(#paint2_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 18H3"
        stroke="url(#paint3_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 18H23"
        stroke="url(#paint4_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3594 11.6397L19.7794 10.2197"
        stroke="url(#paint5_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 22H1"
        stroke="url(#paint6_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 5L12 9L8 5"
        stroke="url(#paint7_linear_702_6616)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_702_6616"
          x1="8.68317"
          y1="14.8841"
          x2="16.2751"
          y2="15.4042"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_702_6616"
          x1="12.1683"
          y1="4.63768"
          x2="12.9311"
          y2="4.64141"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_702_6616"
          x1="4.45776"
          y1="10.7548"
          x2="5.5396"
          y2="10.7919"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_702_6616"
          x1="1.33663"
          y1="18.3768"
          x2="2.85502"
          y2="18.4808"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_702_6616"
          x1="21.3366"
          y1="18.3768"
          x2="22.855"
          y2="18.4808"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_702_6616"
          x1="18.5984"
          y1="10.7548"
          x2="19.6802"
          y2="10.7919"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_702_6616"
          x1="4.70297"
          y1="22.3768"
          x2="15.4045"
          y2="30.4425"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_702_6616"
          x1="9.34653"
          y1="6.50725"
          x2="15.4201"
          y2="6.92339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4E48F2" />
          <stop offset="1" stopColor="#8458FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
